module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal animated is-active"
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card is-large",
    staticStyle: {
      "min-height": "80%"
    }
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.subjects), function(subject, index) {
    return _c('tr', {
      key: subject.id
    }, [_c('td', [_vm._v(_vm._s(subject.subject))]), _vm._v(" "), _c('td', [_c('v-select', {
      ref: "select",
      refInFor: true,
      attrs: {
        "options": _vm.parseUser(),
        "multiple": "",
        "item-value": "",
        "placeholder": "Not assigned"
      },
      model: {
        value: (_vm.internal_users[index]),
        callback: function($$v) {
          _vm.$set(_vm.internal_users, index, $$v)
        },
        expression: "internal_users[index]"
      }
    })], 1)])
  })], 2)]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('div', {
    staticClass: "control is-grouped is-pulled-right"
  }, [_c('p', {
    staticClass: "control is-pulled-right"
  }, [_c('a', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.close(true)
      }
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('a', {
    class: {
      'button': true,
      'is-success': true
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Save")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v("Ticket Config")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Subject")]), _vm._v(" "), _c('th', [_vm._v("Internal User")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46f056a4","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/occurrences/OccurrenceConfig.vue
// module id = 1122
// module chunks = 39